export const APP_VERSION = 'v1.8.0';
